import {
  Arr,
  ArrInt
} from '../../../../lib/Array.lib';
import {
  NOT,
  YES
} from '../../../../lib/Boolean.lib';
import Definition, {
  DEFINITION_CATEGORY__JOB_PREFERENCE,
  ID__TAG__JOB_PREFERENCE__COMPANIES_AVOID,
  ID__TAG__JOB_PREFERENCE__COMPANIES_TARGET,
  ID__TAG__JOB_PREFERENCE__SCHOOLS_AVOID,
  ID__TAG__JOB_PREFERENCE__SCHOOLS_TARGET
} from '../../../../lib/Definition';
import {
  Obj
} from '../../../../lib/Object.lib';
import {
  evaluateAnyHaves,
  haveDecision
} from './Complex.lib';
import {
  evaluatePositiveSignal
} from './PositiveSignals.lib';

const MAPPING__CATEGORY_TO_FIELD = {
  technicalSkills: 'technicalSkills',   // candidate has array
  positiveSignals: 'positiveSignals',   // candidate has array
  negativeSignals: 'negativeSignals',   // candidate has array
  experience: 'level',                  // candidate has integer
  technologyDomain: 'technologyDomain',  // candidate has array
};


export function evaluateChip({
  have,
  candidate,
  job,
}) {
  have = Obj(have);
  candidate = Obj(candidate);
  job = Obj(job);
  have.match = false;
  if (MAPPING__CATEGORY_TO_FIELD[have.key] === 'level') {
    const candidateLevel = Definition.getLabel('level', parseInt(candidate.level));
    const haveExperience = Definition.getLabel('experience', parseInt(have.value));
    have.match = (haveExperience === candidateLevel);
  }
  else if (MAPPING__CATEGORY_TO_FIELD[have.key] === 'positiveSignals') {
    have.match = evaluatePositiveSignal({
      jobSignalTagId: parseInt(have.value),
      candidateSignalTagIds: ArrInt(candidate[MAPPING__CATEGORY_TO_FIELD[have.key]])
    });
  }
  else if (!!have.category && have.category === 'technicalSkills') {
    const additionalMappers = [
      ...Arr(candidate[have.category]),
      ...Arr(candidate._strongTechnicalSkills),
      ...Arr(candidate.techSkillsInResume),
    ].map((tagId) => parseInt(tagId));
    have.match = additionalMappers.includes(parseInt(have.value));
  }
  else if (
    have.key === DEFINITION_CATEGORY__JOB_PREFERENCE
  ) {
    const LIST__EMPLOYMENT_HISTORIES = Arr(
      candidate.employmentHistories
    );
    const LIST__EDUCATION_HISTORIES = Arr(
      candidate.educationHistories
    );

    // SCHOOLS TARGET
    if (
      have.value === ID__TAG__JOB_PREFERENCE__SCHOOLS_TARGET
    ) {
      const LIST__SCHOOLS_TARGET = Arr(
        job.jobPreferences?.schools?.target
      )
      have.match = YES(
        LIST__EDUCATION_HISTORIES.length > 0 &&
        LIST__EDUCATION_HISTORIES.find(
          (educationHistory) => LIST__SCHOOLS_TARGET.includes(
            educationHistory?.schoolId
          )
        )
      );
    }

    // SCHOOLS AVOID
    else if (
      have.value === ID__TAG__JOB_PREFERENCE__SCHOOLS_AVOID
    ) {
      const LIST__SCHOOLS_AVOID = Arr(
        job.jobPreferences?.schools?.avoid
      )
      have.match = NOT(
        LIST__EDUCATION_HISTORIES.length > 0 &&
        LIST__EDUCATION_HISTORIES.find(
          (educationHistory) => LIST__SCHOOLS_AVOID.includes(
            educationHistory?.schoolId
          )
        )
      );
    }

    // COMPANIES TARGET
    else if (
      have.value === ID__TAG__JOB_PREFERENCE__COMPANIES_TARGET
    ) {
      const LIST__COMPANIES_TARGET = Arr(
        job.jobPreferences?.companies?.target
      )
      have.match = YES(
        LIST__EMPLOYMENT_HISTORIES.length > 0 &&
        LIST__EMPLOYMENT_HISTORIES.find(
          (employmentHistory) => LIST__COMPANIES_TARGET.includes(
            employmentHistory?.companyId
          )
        )
      );
    }

    // COMPANIES AVOID
    else if (
      have.value === ID__TAG__JOB_PREFERENCE__COMPANIES_AVOID
    ) {
      const LIST__COMPANIES_AVOID = Arr(
        job.jobPreferences?.companies?.avoid
      )
      have.match = NOT(
        LIST__EMPLOYMENT_HISTORIES.length > 0 &&
        LIST__EMPLOYMENT_HISTORIES.find(
          (employmentHistory) => LIST__COMPANIES_AVOID.includes(
            employmentHistory?.companyId
          )
        )
      );
    }
  }
  else {
    if (!!have.key) {
      const parsedToMatch = candidate[
        MAPPING__CATEGORY_TO_FIELD[have.key]
      ].map(
        (tagId) => parseInt(tagId)
      );
      have.match = parsedToMatch.includes(parseInt(have.value));
    }
  }
  return YES(have.match);
}

export function evaluateChipWithDecision({ have, candidate }) {
  return evaluateAnyHaves({
    decisions: [
      haveDecision(
        evaluateChip({ have, candidate })
      )
    ]
  });
}
